import React from 'react';
import { Button } from '@mui/material';
import { StudioFlowColors, StudioFlowRadii } from '../studioFlowTheme';

interface FlowPrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
  form?: string;
  fullWidth?: boolean;
}

export const FlowPrimaryButton: React.FC<FlowPrimaryButtonProps> = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  form,
  fullWidth = true,
}) => (
  <Button
    type={type}
    form={form}
    onClick={onClick}
    disabled={disabled}
    fullWidth={fullWidth}
    sx={{
      bgcolor: disabled ? StudioFlowColors.disabled : StudioFlowColors.primary,
      color: disabled ? StudioFlowColors.disabledText : '#FFFFFF',
      borderRadius: `${StudioFlowRadii.pill}px`,
      minHeight: 52,
      textTransform: 'none',
      fontWeight: 700,
      fontSize: '15px',
      letterSpacing: '-0.15px',
      fontFamily: StudioFlowColors.bodyFontFamily,
      boxShadow: 'none',
      '&:hover': {
        bgcolor: disabled ? StudioFlowColors.disabled : StudioFlowColors.primaryHover,
        boxShadow: 'none',
      },
      '&.Mui-disabled': {
        bgcolor: StudioFlowColors.disabled,
        color: StudioFlowColors.disabledText,
      },
    }}
  >
    {children}
  </Button>
);
